import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {PaginationInstance} from "ngx-pagination";
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-custom-paginator',
    templateUrl: './custom-paginator.component.html',
    styleUrls: ['./custom-paginator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomPaginatorComponent implements OnInit {

    @Input() elementsArray;
    @Input() paginationConfig: PaginationInstance;
    faAngleDoubleRight: any = faAngleDoubleRight;
    faAngleRight: any = faAngleRight;
    faAngleDoubleLeft: any = faAngleDoubleLeft;
    faAngleLeft: any = faAngleLeft;

    constructor() {

    }

    ngOnInit(): void {
    }

}
